module.exports = __webpack_public_path__ + "media/images/sp/specials/common/present_flower_tvb-94bb89ee56cdcf66c5c0340b58159d72.jpg";